import styled from "styled-components";
import svLocale from "dayjs/locale/sv";
import { Calendar as FrostCalendar } from "frost-ui-react";
import type { CalendarStyles } from "frost-ui-react";
import { appTheme } from "@styles/Theme";
import { colord } from "colord";
import type { Job } from "@models/Job";

interface Props {
	compact?: boolean;
	weeks?: number;
	shifts: Job["shifts"];
	className?: string;
}

export const Calendar: React.FC<Props> = ({ compact, weeks, className, shifts = [] }) => {
	const focusOnDate = shifts[0] ? new Date(shifts[0].start) : new Date();

	return (
		<Styles className={className}>
			<div className="cal-wrapper">
				<FrostCalendar
					displayRanges={[]}
					weeks={weeks}
					monthFormat={compact ? "MMM" : "MMMM"}
					focusOnDate={focusOnDate}
					highlights={shifts.map((s: { start: string | Date }) => ({
						date: new Date(s.start),
						type: "today",
					}))}
					locale={svLocale}
					styles={compact ? compactStyles : defaultStyles}
					weekdayFormat="d"
				/>
			</div>
		</Styles>
	);
};

const Styles = styled.div`
	.cal-wrapper {
		/* margin: 1.5rem 0; */
	}
`;

const defaultStyles: CalendarStyles = {
	highlightStyles: {
		hasJob: {
			backgroundColor: appTheme.colors.brand,
			borderColor: colord(appTheme.colors.brand).darken(0.1).toHex(),
			color: "white",
		},
		today: {
			backgroundColor: "#777",
			borderColor: "black",
			color: "white",
		},
	},
	rangeStyles: {
		disabled: {
			color: "#bbb",
			textDecoration: "line-through",
		},
		range: {
			backgroundColor: "rgba(0, 166, 153, 0.7)",
			color: "white",
			handle: {
				borderColor: "rgb(0, 166, 153)",
			},
		},
	},
	hoverStyles: {
		borderColor: "rgba(0, 166, 153, 0.3)",
	},
};

const compactStyles: CalendarStyles = {
	...defaultStyles,
	dayFontSize: 12,
	weekDayFontSize: 10,
	circleFontSizeRatio: 2.5,
	headerFontSize: 13,
	arrowSize: 13,
};
